export default {
  title: 'Display settings',
  subtitle: 'Select the charts you want to display on the dashboard from the lists below.',
  aggregationTitle: 'Aggregation',
  aggregationDescription: 'These charts show the efficiency for the complete selected time range.',
};
